import axios from 'axios'
import toast from 'react-hot-toast'
import { API_BASE_URL, STORAGE_KEYS } from '../utils/constants'

// Crear instancia de Axios
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor de request para añadir token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor de response para manejar errores
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Manejar errores comunes
    if (error.response) {
      const { status, data } = error.response

      switch (status) {
        case 401:
          // No autenticado - limpiar sesión y redirigir a login
          localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN)
          localStorage.removeItem(STORAGE_KEYS.USER_DATA)
          window.location.href = '/login'
          toast.error('Sesión expirada. Por favor, inicia sesión nuevamente.')
          break

        case 403:
          toast.error('No tienes permisos para realizar esta acción')
          break

        case 404:
          toast.error('Recurso no encontrado')
          break

        case 500:
          toast.error('Error del servidor. Intenta nuevamente más tarde.')
          break

        default:
          // La API puede devolver errores con { message } o { code, message }
          const message = data?.message || data?.payload?.message || 'Error al procesar la solicitud'
          toast.error(message)
      }
    } else if (error.request) {
      // Error de red
      toast.error('Error de conexión. Verifica tu conexión a internet.')
    } else {
      toast.error('Error inesperado')
    }

    return Promise.reject(error)
  }
)

export default apiClient
